import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../utils';
import { partnerApiPath } from '../apiPath';
import { partnerHttpClient } from '../httpClient';

const GetCuratorCategoriesRequestSchema = z
  .object({
    platform: z.enum(['MUSINSA', '29CM']).describe('플랫폼'),
  })
  .describe('GetCuratorCategoriesRequestSchema');

export type GetCuratorCategoriesRequest = z.infer<typeof GetCuratorCategoriesRequestSchema>;

// 큐레이터 주력 카테고리 드롭다운 항목. 카테고리 많은 순으로 내려온다. (CMQA-7121)
export const CuratorCategoryItemSchema = z.object({
  categoryCode: z.string(),
  categoryName: z.string(),
});
export type CuratorCategoryItem = z.infer<typeof CuratorCategoryItemSchema>;

const GetCuratorCategoriesResponseDataSchema = z
  .object({
    list: z.array(CuratorCategoryItemSchema),
  })
  .describe('GetCuratorCategoriesResponseDataSchema');

const GetCuratorCategoriesResponseSchema = createApiResponseSchema(
  GetCuratorCategoriesResponseDataSchema,
);

export type GetCuratorCategoriesResponse = z.infer<typeof GetCuratorCategoriesResponseSchema>;

export const getCuratorCategories = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCuratorCategoriesRequestSchema),
    async (params: GetCuratorCategoriesRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetCuratorCategoriesResponse>(
          partnerApiPath.getCuratorCategories,
          params,
        ),
      ),
    validateApiResponse(GetCuratorCategoriesResponseSchema),
  ),
);
